/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, ViewChild, ViewEncapsulation, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CommonModule, CurrencyPipe, DecimalPipe, formatDate, isPlatformBrowser } from '@angular/common';
import { map, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../shared/services/payment.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';

import { StorageEnum } from '../../shared/enums/storage.enum';
import { PaymentAccountType } from '../../shared/enums/paymentaccounttype.enum';
import { BankAccountType } from '../../shared/enums/bankaccounttype.enum';
import { PaymentMethod } from '../../shared/models/payment-method';
import { NgxMaskDirective } from 'ngx-mask';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { BankPayment, CardPayment, Payment, PaymentResponse } from '../../shared/models/payment';
import { CreditPipe } from '../../shared/pipes/credit.pipe';
import { DialogResultType } from '../../shared/enums/dialogresulttype.enum';
import { ErrorData } from '../../shared/models/error-data';
import { PaymentErrorCode } from '../../shared/enums/paymenterrorcode.enum';
import { CTA, Link, SuccessData } from '../../shared/models/success-data.model';
import { Nav } from '../../shared/enums/nav.enum';
import { EmailInfo } from '../../shared/models/email-info';
import { emailValidator } from '../../shared/validators/email.validator';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { OtherAmountValidator } from '../../payment-feature/other-amount-validator';
import { AccountLookUp } from '../../shared/models/account-lookup';
import { EmailFormComponent } from '../../shared/components/email-form/email-form.component';
import { Person } from '../../shared/models/person';
import { ServiceAddress } from '../../shared/models/service-address';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
import { PaymentusService } from '../../shared/services/paymentus.service';
import { OneTimePaymentPixelModalComponent } from '../one-time-payment-pixel-modal/one-time-payment-pixel-modal.component';
import { PaymentDialogResult } from '../../shared/models/payment-dialog-result';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-one-time-payment-pixel',
  templateUrl: './one-time-payment-pixel.component.html',
  styleUrl: './one-time-payment-pixel.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    NgxMaskDirective,
    MatDividerModule,
    MatCardModule,
    MatCheckboxModule,
    MatTooltipModule,
    CreditPipe,
    EmailFormComponent,
    NotificationComponent,
    PageHeaderComponent,
  ],
  providers: [CreditPipe, CurrencyPipe, DecimalPipe],
})
export class OneTimePaymentPixelComponent implements OnInit {
  pageReady = false;
  paymethods: PaymentMethod[] = [];
  accountLookup: AccountLookUp = new AccountLookUp();
  paymentAmounts: any[] = [];
  paymentForm: FormGroup;
  pageLabels$!: Observable<any>;
  pageLabels: any = {};
  isBrowser = false;
  todaysDay: string = formatDate(new Date(), 'MM/dd/yyy', 'en-us');
  formErrorMessage?: string = '';
  paySummaryMethodLabel = '';
  paymentErrors: any[] = [];
  paymentusErrors: any[] = [];
  @ViewChild('payAmount') payAmountEl!: HTMLElement;
  selectedPaymethodType = '';
  emailFormData: any = {};
  pageName = 'Payment';
  paymentFirstName?: string = '';
  paymentLastName?: string = '';
  headerData = new PageHeader();
  showEmail = true;
  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    public dialog: MatDialog,
    private readonly utils: UtilService,
    private readonly payment: PaymentService,
    private readonly storage: StorageService,
    private readonly fb: FormBuilder,
    private readonly cms: CmsService,
    private readonly router: Router,
    private readonly currencyP: CurrencyPipe,
    private readonly creditP: CreditPipe,
    private readonly decimalPipe: DecimalPipe,
    private readonly notifi: NotificationsService,
    private readonly seoS: SeoService,
    private readonly paymentusSvc: PaymentusService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.accountLookup = this.storage.getSession(StorageEnum.AccountLookUp);
      this.paymentErrors = this.storage.getSession(StorageEnum.GlobalVars)?.paymentErrors;
      this.paymentusErrors = this.storage.getSession(StorageEnum.GlobalVars)?.paymentusErrors;
    }
    this.paymentForm = this.fb.group({
      paydate: ['', [Validators.required, this.validatePaymentDate.bind(this)]],
      paymethod: this.fb.control<PaymentMethod | null>(null, [Validators.required]),
      payamount: [null, [Validators.required]],
      otheramount: [null],
    });
    this.paymentForm.get('otheramount')?.disable();
    this.paymentForm.setValidators(OtherAmountValidator());
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-payment', 'Payment')
      .pipe(
        map((data) => {
          const labelList: any = [];
          const dataCopy = JSON.parse(JSON.stringify(data));

          data.paymentSuccessLabelsList.forEach((label: any) => {
            labelList.push({ name: label.labels.value.name, data: label.labels.value.data });
          });
          dataCopy.paymentSuccessLabelsList = labelList;
          return dataCopy;
        }),
      )
      .subscribe((data: any) => {
        this.pageLabels = data;
        this.headerData.Message = this.pageLabels.paymentHeaderText;
        this.headerData.ShowAccountInfo = false;
        this.seoS.setSeoTags(data.seo);

        if (this.isBrowser) {
          this.getPaymentOptions();

          this.addNewCardAndBankOptions(this.paymethods);
          this.paymethods = this.payment.sortPaymentMethods(
            this.paymethods,
            true,
            this.accountLookup.IsLimitedPayOptions,
          );
          this.displayPaymentPreNotifications();
          this.setupEmailData();
          this.paymentForm.get('paydate')?.setValue(this.todaysDay);
          this.utils.hideSpinner();
          this.pageReady = true;
        }
      });
  }

  checkOtherAmount(): void {
    if (this.paymentForm.get('payamount')?.value === 'other') {
      this.paymentForm.get('otheramount')?.enable();
    } else {
      this.paymentForm.get('otheramount')?.disable();
    }
  }

  otherClicked(): void {
    const payamountVal = this.paymentForm.get('payamount');
    if (payamountVal?.value !== 'other') {
      payamountVal?.patchValue('other');
      this.checkOtherAmount();
    }
  }

  openPixelForm(): void {
    this.utils.showSpinner();
    this.paymentusSvc
      .getPaymentusTokenPixel()
      .pipe(
        finalize(() => {
          this.utils.hideSpinner();
        }),
      )
      .subscribe({
        next: (token) => {
          if (this.utils.isNullOrWhitespace(token)) {
            const newPaymentsErrorMessage = this.paymentusErrors.find(
              (error: { paymentusError?: { errorCode?: string } }) => {
                return error.paymentusError?.errorCode === '90002-sdk-error';
              },
            );
            this.showFormErrorLabel(newPaymentsErrorMessage?.paymentusError?.displayMessage);
            this.paymentForm.patchValue({ paymethod: null });
            this.paySummaryMethodLabel = '';
            return;
          }

          const dialogRefPixel = this.dialog.open(OneTimePaymentPixelModalComponent, {
            // enterAnimationDuration: '100ms',
            panelClass: 'gs-pixel-dialog',
            disableClose: true,
            data: {
              isLimitedPaymentOptions: this.accountLookup.IsLimitedPayOptions,
              pixelJwtToken: token,
            },
          });
          dialogRefPixel.updatePosition({ top: '30px' });
          dialogRefPixel.afterClosed().subscribe((result: PaymentDialogResult) => {
            this.utils.showSpinner();
            if (result.Type === DialogResultType.Cancel) {
              this.paymentForm.patchValue({ paymethod: null });
              this.paySummaryMethodLabel = '';
              this.utils.hideSpinner();
            } else if (result.Type === DialogResultType.Add) {
              // reset/remove the current one time payment method if exists
              this.payment.removeCurrentOneTimePayMethod(this.paymethods);
              this.payment.addNewPayMethod(this.paymethods, result.PayMethod);
              this.paymethods = this.payment.sortPaymentMethods(
                this.paymethods,
                true,
                this.accountLookup.IsLimitedPayOptions,
              );
              if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
                const newSelectedMethod = this.paymethods.find((pm) => {
                  return pm.ReferenceId === result.PayMethod.ReferenceId;
                });
                this.paymentForm.patchValue({ paymethod: newSelectedMethod });
                this.setPaySummaryMethodLabel();
                this.selectedPaymethodType = this.payment.isCardBankDigital(newSelectedMethod?.PaymentAccountType);
                this.payAmountNotifications();
              }
              this.paymentFirstName = result.OneTimePaymentFirstName;
              this.paymentLastName = result.OneTimePaymentLastName;
            } else if (result.Type === DialogResultType.Error) {
              this.paymentForm.patchValue({ paymethod: null });
              this.paySummaryMethodLabel = '';
              this.showFormErrorLabel(result.ErrorMessage);
              this.utils.hideSpinner();
            }
            this.storage.setSession(StorageEnum.PaymentMethods, this.paymethods);
            this.utils.hideSpinner();
          });
        },
        error: () => {
          const newPaymentsErrorMessage = this.paymentusErrors.find(
            (error: { paymentusError?: { errorCode?: string } }) => {
              return error.paymentusError?.errorCode === '90002-sdk-error';
            },
          );
          this.showFormErrorLabel(newPaymentsErrorMessage?.paymentusError?.displayMessage);
          this.paymentForm.patchValue({ paymethod: null });
          this.paySummaryMethodLabel = '';
        },
      });
  }

  addNewCardAndBankOptions(paymethodsList: PaymentMethod[]): void {
    const cardOrCheckPayment = new PaymentMethod();
    cardOrCheckPayment.PaymentAccountType = PaymentAccountType.Card;
    cardOrCheckPayment.Description = this.pageLabels.paymentMethodNewPaymentMethod;
    paymethodsList.push(cardOrCheckPayment);

    const cashCheckPayment = new PaymentMethod();
    cashCheckPayment.PaymentAccountType = PaymentAccountType.Cash;
    cashCheckPayment.Description = this.pageLabels.payMethodCashText;
    paymethodsList.push(cashCheckPayment);
  }

  displayPaymentPreNotifications(): void {
    if (this.accountLookup.IsLimitedPayOptions) {
      this.notifi.addNotification(
        this.pageLabels.oneTimePaymentLimitedPaymentOptionsPreNotification,
        NotificationType.Alert,
        this.pageName,
      );
    }
  }

  validatePaymentDate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return { required: true };
    }
    return null;
  }

  setPaySummaryMethodLabel(): void {
    this.paySummaryMethodLabel = this.paymentForm.get('paymethod')?.value?.Description;
  }

  paymethodChanged(): void {
    this.setPaySummaryMethodLabel();
    this.showEmail = true;
    const selectedPaymethod: PaymentMethod = this.paymentForm.get('paymethod')?.value;
    this.selectedPaymethodType = this.payment.isCardBankDigital(selectedPaymethod.PaymentAccountType);
    if (this.selectedPaymethodType === 'BANK') {
      if (!selectedPaymethod.ReferenceId) {
        this.openPixelForm();
      }
    } else if (this.selectedPaymethodType === 'CARD') {
      if (!selectedPaymethod.ReferenceId) {
        this.openPixelForm();
      }
    } else if (this.selectedPaymethodType === 'CASH') {
      this.showEmail = false;
      this.utils.consoleLog('cash money');
    } else {
      this.utils.consoleLog(`selectedPaymethodType: ${this.selectedPaymethodType}`);
    }
    this.payAmountNotifications();
  }

  payAmountNotifications(): void {
    this.notifi.deleteNotification(this.pageLabels.maxBankAmountPostNotification);
    this.notifi.deleteNotification(this.pageLabels.maxCardAmountPostNotification);
    const payType = this.paymentForm.get('paymethod')?.value?.PaymentAccountType ?? PaymentAccountType.Unknown;
    const totalBalance = this.accountLookup?.CurrentBalance ?? 0;
    if (payType === PaymentAccountType.Banking && totalBalance > 1000000) {
      this.notifi.addNotification(this.pageLabels.maxBankAmountPostNotification, NotificationType.Alert, this.pageName);
    }

    if (
      payType !== PaymentAccountType.Unknown &&
      payType !== PaymentAccountType.Banking &&
      payType !== PaymentAccountType.Cash &&
      totalBalance > 50000
    ) {
      this.notifi.addNotification(this.pageLabels.maxCardAmountPostNotification, NotificationType.Alert, this.pageName);
    }
  }

  getPaymentOptions(): void {
    const current = this.accountLookup?.CurrentBalance ?? 0;
    const pastDue = this.accountLookup?.PastDueBalance ?? 0;
    const minDue = this.accountLookup?.MinimumPayment ?? 0;
    this.paymentAmounts = [];

    if (current <= 0) {
      this.paymentAmounts.push({
        label: this.pageLabels.payAmountTotalLabel,
        amount: current,
        disable: true,
        tooltip: this.pageLabels.payAmountTotalTooltip,
      });
      this.otherClicked();
    } else {
      // check for specific headline codes
      if (current === minDue && minDue === pastDue) {
        // show min Due
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountMinDueLabel,
          amount: minDue,
          disable: false,
          tooltip: this.pageLabels.payAmountMinDueTooltip,
        });
      } else if (current === pastDue && minDue === 0) {
        // show past due
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountPastDueLabel,
          amount: pastDue,
          disable: false,
          tooltip: this.pageLabels.payAmountPastDueTooltip,
        });
      } else if (current === pastDue && pastDue !== minDue) {
        // show pastDue and minDue
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountPastDueLabel,
          amount: pastDue,
          disable: false,
          tooltip: this.pageLabels.payAmountPastDueTooltip,
        });
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountMinDueLabel,
          amount: minDue,
          disable: false,
          tooltip: this.pageLabels.payAmountMinDueTooltip,
        });
      } else if (current !== pastDue && pastDue === minDue && minDue > 0) {
        // show current and min
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountTotalLabel,
          amount: current,
          disable: false,
          tooltip: this.pageLabels.payAmountTotalTooltip,
        });
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountMinDueLabel,
          amount: minDue,
          disable: false,
          tooltip: this.pageLabels.payAmountMinDueTooltip,
        });
      } else if (current !== pastDue && pastDue !== minDue) {
        // show total,  pastDue and minDue
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountTotalLabel,
          amount: current,
          disable: false,
          tooltip: this.pageLabels.payAmountTotalTooltip,
        });
        if (pastDue > 0) {
          this.paymentAmounts.push({
            label: this.pageLabels.payAmountPastDueLabel,
            amount: pastDue,
            disable: false,
            tooltip: this.pageLabels.payAmountPastDueTooltip,
          });
        }
        if (minDue > 0) {
          this.paymentAmounts.push({
            label: this.pageLabels.payAmountMinDueLabel,
            amount: minDue,
            disable: false,
            tooltip: this.pageLabels.payAmountMinDueTooltip,
          });
        }
      } else {
        // show current
        this.paymentAmounts.push({
          label: this.pageLabels.payAmountTotalLabel,
          amount: current,
          disable: false,
          tooltip: this.pageLabels.payAmountTotalTooltip,
        });
      }
      // Set Pay Amount to first item in the list, since we are Selecting it by default.
      // so Pay button in Summary section will have amount populated
      this.paymentForm.get('payamount')?.setValue(this.paymentAmounts[0].amount);
    }
  }

  showFormErrorLabel(errorMessage?: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  onSubmit(): void {
    this.formErrorMessage = '';
    this.paymentForm.markAllAsTouched();
    this.emailFormData.formGroup.markAllAsTouched();
    if (this.paymentForm.valid && this.emailFormData.formGroup.valid) {
      this.utils.showSpinner();
      if (this.paymentForm.get('paymethod')?.value?.PaymentAccountType !== PaymentAccountType.Banking) {
        this.makeCardPayment();
      } else {
        this.makeBankPayment();
      }
    } else {
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.showFormErrorLabel(errorMessage);
    }
  }

  setSuccessData(payRequest: BankPayment, payResponse: PaymentResponse): void {
    let cta = new CTA();
    let paymentCTA;
    const successLabels = this.pageLabels.paymentSuccessLabelsList.find((labels: any) => {
      return labels.name === 'PaymentSuccess';
    }).data;
    const email = this.emailFormData.formGroup.value.email;
    const success = new SuccessData();
    success.Header = successLabels.header;
    success.Subheader = successLabels.subheaderText.replace('{0}', email);
    success.PaymentAmount.Label = successLabels.paymentAmountLabel;
    success.PaymentAmount.Value = payRequest.Amount!;
    if (this.selectedPaymethodType === 'DIGITAL') {
      const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: `${selectedPaymethod.PaymentAccountType}`,
      });
    } else {
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: this.payment.getPaymethodDescription(
          payRequest.PaymentAccountType as PaymentAccountType,
          payRequest.LastFour,
          payRequest.Nickname,
        ),
      });
    }
    success.Details.push({ Label: successLabels.details[1].detailLabel, Value: `${payResponse.ConfirmationNumber}` });
    success.Details.push({
      Label: successLabels.details[2].detailLabel,
      Value: `${this.creditP.transform(this.currencyP.transform(payResponse.CurrentBalance))}`,
    });

    success.OneTimePaymentDetailPostMessage = successLabels.oneTimePaymentDetailPostMessage;

    paymentCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'registerNewAccount';
    });
    cta.Label = paymentCTA.ctaLabel;
    cta.AriaLabel = paymentCTA.ctaAriaLabel;
    cta.Link = paymentCTA.ctaUrl;
    success.CTAList.push(cta);

    cta = new CTA();
    paymentCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'oneTimePayment';
    });
    cta.Label = paymentCTA.ctaLabel;
    cta.AriaLabel = paymentCTA.ctaAriaLabel;
    cta.Link = paymentCTA.ctaUrl;
    success.CTAList.push(cta);

    const linkList = new Link();
    const paymentLink = successLabels.linkList.find((linkList: any) => {
      return linkList.linkId === 'oneTimePaymentCloseLink';
    });
    linkList.Label = paymentLink.linkLabel;
    linkList.Link = paymentLink.linkUrl;
    linkList.AriaLabel = paymentLink.linkAltText;
    success.LinkList.push(linkList);

    // put updated data into storage
    this.accountLookup.CurrentBalance = payResponse.CurrentBalance;
    this.accountLookup.MinimumPayment = payResponse.MinimumPayment;
    this.accountLookup.PastDueBalance = payResponse.PastDueBalance;
    this.storage.setSession(StorageEnum.AccountLookUp, this.accountLookup);
    this.storage.setSession(StorageEnum.SuccessData, success);
  }

  setSuccessDataWithError(payRequest: BankPayment, errorCode: string): void {
    let cta = new CTA();
    let paymentCTA;
    const successLabels = this.pageLabels.paymentSuccessLabelsList.find((labels: any) => {
      return labels.name === 'PaymentSuccess';
    }).data;
    const success = new SuccessData();
    const newPaymentError = this.paymentErrors.find((error) => {
      return error.paymentError?.errorCode === errorCode;
    });

    success.Header = newPaymentError.paymentError?.errorHeader; // errorDetail.Header;
    success.Subheader = newPaymentError.paymentError?.displayMessage;
    success.PaymentAmount.Label = successLabels.paymentAmountLabel;
    success.PaymentAmount.Value = payRequest.Amount!;
    if (this.selectedPaymethodType === 'DIGITAL') {
      const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: `${selectedPaymethod.PaymentAccountType}`,
      });
    } else {
      success.Details.push({
        Label: successLabels.details[0].detailLabel,
        Value: this.payment.getPaymethodDescription(
          payRequest.PaymentAccountType as PaymentAccountType,
          payRequest.LastFour,
          payRequest.Nickname,
        ),
      });
    }
    success.Details.push({
      Label: successLabels.details[4].detailLabel,
      Value: `${this.creditP.transform(this.currencyP.transform(payRequest.CurrentBalance))}`,
    });

    success.OneTimePaymentDetailPostMessage = successLabels.oneTimePaymentDetailPostMessage;

    paymentCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'registerNewAccount';
    });
    cta.Label = paymentCTA.ctaLabel;
    cta.AriaLabel = paymentCTA.ctaAriaLabel;
    cta.Link = paymentCTA.ctaUrl;
    success.CTAList.push(cta);

    cta = new CTA();
    paymentCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'oneTimePayment';
    });
    cta.Label = paymentCTA.ctaLabel;
    cta.AriaLabel = paymentCTA.ctaAriaLabel;
    cta.Link = paymentCTA.ctaUrl;
    success.CTAList.push(cta);

    const linkList = new Link();
    const paymentLink = successLabels.linkList.find((linkList: any) => {
      return linkList.linkId === 'oneTimePaymentCloseLink';
    });
    linkList.Label = paymentLink.linkLabel;
    linkList.Link = paymentLink.linkUrl;
    linkList.AriaLabel = paymentLink.linkAltText;
    success.LinkList.push(linkList);
    this.storage.setSession(StorageEnum.SuccessData, success);
  }

  makeBankPayment(): void {
    const payRequest = this.buildBankRequest();
    this.payment.makeBankPayment(payRequest).subscribe({
      error: (e) => {
        if (e.message === PaymentErrorCode.PaymentNotPostedtoCCS) {
          this.setSuccessDataWithError(payRequest, e.message);
          void this.router.navigateByUrl(Nav.OneTimePaymentSuccess);
        } else {
          this.setErrorData(e.message, payRequest);
          void this.router.navigateByUrl(Nav.OneTimePaymentError);
        }
      },
      next: (data: PaymentResponse) => {
        this.setSuccessData(payRequest, data);
        void this.router.navigateByUrl(Nav.OneTimePaymentSuccess);
      },
    });
  }

  makeCardPayment(): void {
    const payRequest = this.buildCardRequest();
    this.payment.makeCreditCardPayment(payRequest).subscribe({
      error: (e) => {
        if (e.message === PaymentErrorCode.PaymentNotPostedtoCCS) {
          this.setSuccessDataWithError(payRequest, e.message);
          void this.router.navigateByUrl(Nav.OneTimePaymentSuccess);
        } else {
          this.setErrorData(e.message, payRequest);
          void this.router.navigateByUrl(Nav.OneTimePaymentError);
        }
      },
      next: (data: PaymentResponse) => {
        this.setSuccessData(payRequest, data);
        void this.router.navigateByUrl(Nav.OneTimePaymentSuccess);
      },
    });
  }

  setErrorData(errorCode: string, paymentRequest?: any): void {
    let payType = this.selectedPaymethodType;
    if (this.selectedPaymethodType === 'DIGITAL') {
      const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
      payType = selectedPaymethod.PaymentAccountType;
    } else {
      payType = paymentRequest.Nickname ? paymentRequest.Nickname : paymentRequest.PaymentAccountType;
    }
    const newPaymentError = this.paymentErrors.find((error) => {
      return error.paymentError?.errorCode === errorCode;
    });
    const errorLabels = this.pageLabels.paymentErrorLabels.value.data.ctaList[1];
    const errorLabelsLinks = this.pageLabels.paymentErrorLabels.value.data.linkList[0];
    const errorDetail = new ErrorData();
    errorDetail.ErrorCode = newPaymentError.paymentError?.errorCode;
    errorDetail.Header = newPaymentError.paymentError?.errorHeader;
    let errorMessage = newPaymentError.paymentError?.displayMessage;
    if (paymentRequest) {
      errorMessage = errorMessage.replace('{{$}}', '$' + paymentRequest.Amount);
      errorMessage = errorMessage.replace('{{PaymentType}}', payType);
      errorMessage = errorMessage.replace('{{LastFour}}', paymentRequest.LastFour);
    }
    errorDetail.Subheader = errorMessage;
    errorDetail.CtaButton.Label = errorLabels.ctaLabel;
    errorDetail.CtaButton.Link = errorLabels.ctaUrl;
    errorDetail.CtaButton.AriaLabel = errorLabels.ctaAriaLabel;

    errorDetail.CtaLink.Label = errorLabelsLinks.linkLabel;
    errorDetail.CtaLink.AriaLabel = errorLabelsLinks.linkAltText;
    errorDetail.CtaLink.Link = errorLabelsLinks.linkUrl;
    this.storage.setSession(StorageEnum.ErrorData, errorDetail);
  }

  buildBankRequest(): BankPayment {
    const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
    let bankPayment = new BankPayment();
    bankPayment = this.buildPaymentRequest();
    bankPayment.BankAccountNumber = selectedPaymethod.BankAccountNumber;
    bankPayment.BankRoutingNumber = selectedPaymethod.BankRoutingNumber;
    const bankAccountType = selectedPaymethod.BankAccountType as string | undefined;
    bankPayment.BankAccountType =
      bankAccountType === 'CHQ'
        ? BankAccountType.Checking
        : bankAccountType === 'SAV'
          ? BankAccountType.Savings
          : bankAccountType === 'BUS_CHQ'
            ? BankAccountType.Business
            : selectedPaymethod.BankAccountType;
    return bankPayment;
  }

  buildCardRequest(): CardPayment {
    const selectedPaymethod = this.paymentForm.get('paymethod')?.value;
    let cardPayment = new CardPayment();
    cardPayment = this.buildPaymentRequest();
    cardPayment.ExpirationDate = selectedPaymethod.ExpDate;
    cardPayment.Fee = '0';
    cardPayment.PostalCode = cardPayment.Person?.BillingAddress?.PostalCode;
    cardPayment.Cvv = 0;
    return cardPayment;
  }

  buildPaymentRequest(): Payment {
    const selectedPaymethod = this.paymentForm.get('paymethod')?.value;

    const payment = new Payment();
    const personObject = new Person();
    const emailObject = new EmailInfo();
    const email = this.emailFormData.formGroup.value.email;

    emailObject.ContactId = '';
    emailObject.IsActive = true;
    emailObject.IsPrimary = true;
    emailObject.Type = 'EMAIL';
    emailObject.Email = email;

    const serviceAddressObject = new ServiceAddress();
    serviceAddressObject.PostalCode = this.accountLookup.BillingZipCode;
    serviceAddressObject.State = this.accountLookup.BillingState;

    personObject.FirstName = this.paymentFirstName?.trim();
    personObject.LastName = this.paymentLastName?.trim();
    personObject.AccountNumber = this.accountLookup.AccountNumber;
    personObject.EmailAddresses?.push(emailObject);
    personObject.BillingAddress = serviceAddressObject;
    payment.Person = personObject;
    if (this.paymentForm.get('payamount')?.value === 'other') {
      payment.Amount = this.paymentForm.get('otheramount')?.value;
    } else {
      // update payment amount to include trailing zeros and 2 decimal places.
      let payAmountformatted = this.paymentForm.get('payamount')?.value;
      payAmountformatted = this.decimalPipe.transform(payAmountformatted, '1.2-2');
      payment.Amount = payAmountformatted;
    }
    payment.Date = this.paymentForm.get('paydate')?.value;
    payment.AccountNumber = this.accountLookup.AccountNumber;
    payment.IsInSeverance = this.accountLookup.IsInSeverance;
    payment.Token = selectedPaymethod.ReferenceId;
    payment.LastFour = selectedPaymethod.LastFour;
    payment.PaymentAccountType = selectedPaymethod.PaymentAccountType?.replaceAll(' ', '');
    payment.SaveToAccount = false;
    payment.SaveAsDefault = false;
    payment.CurrentBalance = this.accountLookup.CurrentBalance;
    payment.PastDueBalance = this.accountLookup.PastDueBalance;
    payment.MinimumPayment = this.accountLookup.MinimumPayment;
    return payment;
  }

  findLocations(): void {
    window.open('https://www.gas-south.com/paymentlocations.aspx', '_blank');
  }

  accountHasBalance(): boolean {
    const totalBalance = this.accountLookup?.CurrentBalance ?? 0;
    return totalBalance > 0;
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = false;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
    });
  }
}
